import { Typography } from '../../../components/typography/typography';
import { Spinner } from '../../../components/spinner/spinner';
import { useEffect, useState } from 'react';
import { useAdminApiV1 } from '../../../clients/quipli-service/admin/admin-api-v1';
import { PasswordRequirements } from '../../../clients/quipli-service/admin/admin';
import { toast } from '../../../util/toasts';
import { Button } from '../../../components/form/button';
import Container from '../../../components/container/container';

export const AdminPasswordRequirements = () => {
  const { getPasswordRequirements, updatePasswordRequirements } = useAdminApiV1();
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [passwordRequirements, setPasswordRequirements] = useState<PasswordRequirements>();

  useEffect(() => {
    getPasswordRequirements()
      .then((r) => {
        setPasswordRequirements(r);
      })
      .catch((e) => {
        console.log(e);
        toast('Error loading password requirements', 'error');
      });
  }, []);

  async function savePasswordRequirements() {
    if (passwordRequirements) {
      try {
        setIsSaving(true);
        await updatePasswordRequirements(passwordRequirements);
      } catch (e) {
        console.log(e);
        toast('Error saving password requirements', 'error');
      } finally {
        setIsSaving(false);
      }
    }
  }

  return (
    <div className="container-v2">
      <div className="">
        <div className="flex justify-between items-center">
          <Typography type="display-sm" weight="medium">
            Admin Password Requirements
          </Typography>
        </div>
      </div>

      <Container className="p-2 flex flex-column gap-2 max-w-[25rem]">
        {passwordRequirements && (
          <>
            <div className="input-group">
              <label>
                <Typography type="text-md" weight="semi-bold">
                  Minimum Length
                </Typography>
              </label>
              <input
                type="number"
                value={passwordRequirements.minimumLength}
                min={1}
                onChange={(e) =>
                  setPasswordRequirements((prev) => {
                    return prev ? { ...prev, minimumLength: parseInt(e.target.value) } : prev;
                  })
                }
              />
            </div>
            <div className="input-group">
              <label>
                <Typography type="text-md" weight="semi-bold">
                  Lowercase Characters
                </Typography>
              </label>
              <input
                type="number"
                value={passwordRequirements.lowercaseCharacters}
                min={0}
                onChange={(e) =>
                  setPasswordRequirements((prev) => {
                    return prev ? { ...prev, lowercaseCharacters: parseInt(e.target.value) } : prev;
                  })
                }
              />
            </div>
            <div className="input-group">
              <label>
                <Typography type="text-md" weight="semi-bold">
                  Uppercase Characters
                </Typography>
              </label>
              <input
                type="number"
                value={passwordRequirements.uppercaseCharacters}
                min={0}
                onChange={(e) =>
                  setPasswordRequirements((prev) => {
                    return prev ? { ...prev, uppercaseCharacters: parseInt(e.target.value) } : prev;
                  })
                }
              />
            </div>
            <div className="input-group">
              <label>
                <Typography type="text-md" weight="semi-bold">
                  Numbers
                </Typography>
              </label>
              <input
                type="number"
                value={passwordRequirements.numericCharacters}
                min={0}
                onChange={(e) =>
                  setPasswordRequirements((prev) => {
                    return prev ? { ...prev, numericCharacters: parseInt(e.target.value) } : prev;
                  })
                }
              />
            </div>
            <div className="input-group">
              <label>
                <Typography type="text-md" weight="semi-bold">
                  Special Characters
                </Typography>
              </label>
              <input
                type="number"
                value={passwordRequirements.specialCharacters}
                min={0}
                onChange={(e) =>
                  setPasswordRequirements((prev) => {
                    return prev ? { ...prev, specialCharacters: parseInt(e.target.value) } : prev;
                  })
                }
              />
            </div>
            <div className="flex justify-end">
              <Button className="button-yellow" onClick={savePasswordRequirements} disabled={isSaving}>
                {isSaving ? <Spinner size={1} /> : 'Save'}
              </Button>
            </div>
          </>
        )}
        {!passwordRequirements && <Spinner />}
      </Container>
    </div>
  );
};
